import store from "@/store";

/**
 * Get a list of roles that are allowed to access an URL
 * Route names will be case-insensitive
 *
 * @param name the route name using backend names
 * @returns {[]} a list of role names
 */
export function getRolesForRoute(name) {
  const roles = [store.getters["operators/currentRole"]];
  return (
    roles
      .filter(
        (role) =>
          Array.isArray(role.data.allowedMenuRoutes) && role.data.allowedMenuRoutes.length > 0
      )
      .filter((role) => role.data.allowedMenuRoutes.indexOf(name) >= 0)
      .map((role) => role.name.toLowerCase()) || []
  );
}

/**
 * Get a list of roles that are NOT allowed to access an URL
 * Route names will be case-insensitive
 *
 * @param name the route name using backend names
 * @returns {[]} a list of role names
 */
export function getRolesWithoutRoute(name) {
  const roles = [store.getters["operators/currentRole"]];
  return (
    roles
      .filter(
        (role) =>
          !role.data.allowedMenuRoutes ||
          (role.data.allowedMenuRoutes && role.data.allowedMenuRoutes.indexOf(name) < 0)
      )
      .map((role) => role.name.toLowerCase()) || []
  );
}
